module.exports = __webpack_public_path__ + "static/alexis-ruiz-hero-small-98039960c24891fd611e356cfa31b166.jpg";